import { Directive } from '@angular/core';
import { VehicleMetadata } from 'src/app/_types/lead.types';
import { CarModel } from 'src/app/_types/vehicle.type';
import { getCentralisationInsurerLabel } from 'src/app/enums/centralisation-insurer.enum';
import { getSexEnumLabel } from 'src/app/enums/sex.enum';
import {
  getVehicleCascoEnumLabel,
  getVehicleDistanceLabel,
  getVehicleGarageLabel,
  getVehicleOfferTierLabel,
  getVehiclePrestationLabel,
  getVehicleRequestTypeLabel,
  getVehicleUseLabel,
} from 'src/app/enums/vehicle.enums';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class VehicleMetadataComponentAbstract extends BaseMetadataComponent<VehicleMetadata> {
  getVehicleCascoEnumLabel = getVehicleCascoEnumLabel;

  getVehicleDistanceLabel = getVehicleDistanceLabel;

  getVehicleGarageLabel = getVehicleGarageLabel;

  getVehicleOfferTierLabel = getVehicleOfferTierLabel;

  getVehiclePrestationLabel = getVehiclePrestationLabel;

  getVehicleRequestTypeLabel = getVehicleRequestTypeLabel;

  getVehicleUseLabel = getVehicleUseLabel;

  getBooleanLabel = getBooleanLabel;

  getSexEnumLabel = getSexEnumLabel;

  getCentralisationInsurerLabel = getCentralisationInsurerLabel;

  carModelsEqual(v1?: CarModel, v2?: CarModel) {
    return (
      !!v1 &&
      !!v2 &&
      v1.modelName === v2.modelName &&
      v1.transmission === v2.transmission &&
      v1.power === v2.power &&
      v1.fuel === v2.fuel &&
      v1.body === v2.body &&
      v1.doors === v2.doors
    );
  }

  displayContractualQuestions(metadata: VehicleMetadata) {
    return (
      metadata &&
      ((metadata.isInsured !== null && metadata.isInsured !== undefined) ||
        (metadata.replaceContract !== null &&
          metadata.replaceContract !== undefined) ||
        metadata.oldCompany ||
        (metadata.hasAlreadyLostLicense !== null &&
          metadata.hasAlreadyLostLicense !== undefined) ||
        (metadata.hasAlreadyTakenDamage !== null &&
          metadata.hasAlreadyTakenDamage !== undefined) ||
        metadata.lostLicenseDate ||
        metadata.lostLicenseReason)
    );
  }
}
